import { upperCaseValue } from '@dte/otw-utils-core/src/strings/upperCaseValue';

import { validateString } from '../validateString';

function handleCountryCodeForUS(value: string): string {
	// TODO: this logic would need to change if we want to support international numbers

	// Remove leading 1 if it's there already and we have more than 10 digits (assuming a US number)
	if (value.startsWith('1') && value.length > 10) {
		return value.substring(1);
	}

	return value;
}

export function substitutePhoneNumbersForLetters(value: string | undefined): string {
	// Trim & convert to uppercase
	let validated = upperCaseValue(value) ?? '';

	// Convert letters on keypad to numbers
	validated = validated.replace(/[ABC]/g, '2');
	validated = validated.replace(/[DEF]/g, '3');
	validated = validated.replace(/[GHI]/g, '4');
	validated = validated.replace(/[JKL]/g, '5');
	validated = validated.replace(/[MNO]/g, '6');
	validated = validated.replace(/[PQRS]/g, '7');
	validated = validated.replace(/[TUV]/g, '8');
	validated = validated.replace(/[WXYZ]/g, '9');

	return validated;
}

export function getNumericOnlyPhoneNumber(value: string | undefined): string {
	// Convert letters on keypad to numbers
	let numericOnlyValue = substitutePhoneNumbersForLetters(value);

	// Strip everything else non-numeric
	numericOnlyValue = numericOnlyValue.replace(/[^0-9]/g, '');

	// Remove leading 1 it it's there (assuming a US number)
	numericOnlyValue = handleCountryCodeForUS(numericOnlyValue);

	return numericOnlyValue;
}

export function validatePhoneNumber(value: string | undefined): string | undefined {
	// Convert letters on keypad to numbers
	const validated = getNumericOnlyPhoneNumber(value);

	// TODO: add this back in later when web is ready to handle similar logic
	// checkPhoneForBadNumbers(validated);

	return validateString('US phone numbers', validated, 10, 10, false);
}

export function isValidPhoneNumber(value: string): boolean {
	try {
		validatePhoneNumber(value);
		return true;
	} catch {
		return false;
	}
}
